import React from 'react';
import { Box, Typography } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

interface TrendBadgeProps {
  trend: 'up' | 'down' | 'stable';
  delta?: number;
  size?: 'small' | 'medium';
}

const TrendBadge: React.FC<TrendBadgeProps> = ({ trend, delta, size = 'small' }) => {
  const config = {
    up: { icon: TrendingUpIcon, color: '#2e7d32', bg: '#e8f5e9' },
    down: { icon: TrendingDownIcon, color: '#c62828', bg: '#ffebee' },
    stable: { icon: TrendingFlatIcon, color: '#757575', bg: '#f5f5f5' },
  }[trend];

  const iconSize = size === 'small' ? 14 : 18;
  const fontSize = size === 'small' ? '0.65rem' : '0.75rem';

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, bgcolor: config.bg, borderRadius: 1, px: 0.5, py: 0.15 }}>
      <config.icon sx={{ fontSize: iconSize, color: config.color }} />
      {delta !== undefined && delta !== 0 && (
        <Typography sx={{ fontSize, fontWeight: 600, color: config.color, lineHeight: 1 }}>
          {delta > 0 ? '+' : ''}{delta}
        </Typography>
      )}
    </Box>
  );
};

export default TrendBadge;
